export default "__VITE_ASSET__CPLGiEol__"